'use strict';
import angular from 'angular';
import './inOutStatus.services';

import inOutStatusHtmlUrl from '../views/inOutStatus.html';

angular.module('inOutStatus.directive', ['inOutStatus.services'])

    .directive('inoutStatus', ['InOutStatusService', '$ioAlert', function(InOutStatusService, $ioAlert){
        return {
            restrict : 'E',
            templateUrl : inOutStatusHtmlUrl,
            controller: function($scope) {
                $scope.workflowUser = {};
                $scope.workflowStatusList = [
                    {'id': '36', 'const': 'WORKFLOW_USER_AVAILABLE', 'fa': 'fa-check-circle-o', 'text': 'Available'},
                    {'id': '37', 'const': 'WORKFLOW_USER_AVAILABLE_ON_BREAK', 'fa': 'fa-history', 'text': 'Available on Break'},
                    {'id': '38', 'const': 'WORKFLOW_USER_UNAVAILABLE', 'fa': 'fa-times-circle-o', 'text': 'Unavailable'},
                    {'id': '39', 'const': 'WORKFLOW_USER_ON_EXTENDED_ABSENCE', 'fa': 'fa-times-circle-o', 'text': 'Extended Absence'}
                ];
                $scope.workflowStatusIcon = 'fa-check-circle-o';

                $scope.getCurrentUserStatus = function(){
                    //check if workflow is enabled for dashboard
                    InOutStatusService.getWorkflowEnableStatus().then(function(success){
                        if(!success.errors && success.enabled ){
                            $scope.workflowEnable = success.enabled;
                            InOutStatusService.getCurrentUserStatus().then(function(success){
                                if(!success.errors) {
                                    if(success.workflowUser === false){
                                        var statusItem = $scope.getStatusByConst('WORKFLOW_USER_UNAVAILABLE');
                                        $scope.workflowUser.const = statusItem.const;
                                        $scope.workflowStatusIcon = statusItem.fa;
                                        $scope.workflowStatusConst = statusItem.const;
                                    }else{
                                        $scope.workflowUser = success.workflowUser;
                                        $scope.workflowUser.const = $scope.getStatusConstById($scope.workflowUser.status_id);
                                        var statusItem = $scope.getStatusByConst($scope.workflowUser.const);
                                        $scope.workflowStatusIcon = statusItem.fa;
                                        $scope.workflowStatusConst = statusItem.const;
                                    }

                                }
                            }, function(error){
                                $ioAlert.show('Error!', 'Could not get user status.', 'error');
                            });
                        }
                    }, function(error){
                        $ioAlert.show('Error!', 'Could not get user status.', 'error');
                    });
                }

                $scope.setCurrentUserStatus = function(statusConst){
                    var statusId = $scope.getStatusIdByConst(statusConst);
                    if(statusId){
                        var paramObj = {
                            statusId: statusId
                        };
                        InOutStatusService.addCurrentUserActivity(paramObj).then(function(success){
                            if(success.workflowUserActivity.after_status_id){
                                $scope.workflowUser.status_id = success.workflowUserActivity.after_status_id;
                                $scope.workflowUser.const = $scope.getStatusConstById(success.workflowUserActivity.after_status_id);
                                var statusItem = $scope.getStatusByConst($scope.workflowUser.const);
                                $scope.workflowStatusIcon = statusItem.fa;
                                $scope.workflowStatusConst = statusItem.const;
                            }
                        }, function(error){
                            $ioAlert.show('Error!', 'Unable to add user activity.', 'error');
                        });
                    }
                }

                $scope.getStatusIdByConst = function(statusConst){
                    for(var i = 0, len = $scope.workflowStatusList.length; i<len; i++ ){
                        if($scope.workflowStatusList[i].const == statusConst){
                            return $scope.workflowStatusList[i].id;
                        }
                    }
                    return false;
                }

                $scope.getStatusConstById = function(statusId){
                    for(var i = 0, len = $scope.workflowStatusList.length; i<len; i++ ){
                        if($scope.workflowStatusList[i].id == statusId){
                            return $scope.workflowStatusList[i].const;
                        }
                    }
                    return false;
                }

                $scope.getStatusByConst = function(statusConst){
                    for(var i = 0, len = $scope.workflowStatusList.length; i<len; i++ ){
                        if($scope.workflowStatusList[i].const == statusConst){
                            return $scope.workflowStatusList[i];
                        }
                    }
                    return false;
                }

                $scope.setStatus = function(icon){
                    $scope.setCurrentUserStatus(icon.const)
                }

                $scope.getCurrentUserStatus();
            },
            link: function(scope, elem, attrs) {

            }
        }
    }]);